import { render, staticRenderFns } from "./NoticePreviewDialog.vue?vue&type=template&id=18310822&scoped=true"
import script from "./NoticePreviewDialog.vue?vue&type=script&lang=js"
export * from "./NoticePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./NoticePreviewDialog.vue?vue&type=style&index=0&id=18310822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18310822",
  null
  
)

export default component.exports